import manifest from "./manifest.js";

const aliases = {
  [manifest.SABLIER_LOCKUP]: "LK2",
};

export default aliases;
